<template>
<v-dialog :value="value" max-width="560" @input="$emit('input', $event)" @keydown.esc="close">
  <v-card class="rounded-xl pa-6">
    <!-- Header -->
    <div class="d-flex align-center justify-space-between mb-5">
      <h3 class="text-h6 font-weight-bold grey--text text--darken-3">
        {{isEdit ? 'Редактировать шаблон' : 'Новый шаблон заметки'}}
      </h3>
      <v-btn icon small @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>

    <v-form ref="form" @submit.prevent="submit">
      <!-- Assignment -->
      <div class="mb-4">
        <div class="text-body-2 font-weight-medium grey--text text--darken-2 mb-1">Назначение</div>
        <v-select
          v-model="form.assignment"
          :items="assignmentOptions"
          item-text="label"
          item-value="value"
          outlined
          dense
          hide-details="auto"
        />
      </div>

      <!-- Kind -->
      <div class="mb-4">
        <div class="text-body-2 font-weight-medium grey--text text--darken-2 mb-1">Тип</div>
        <v-select
          v-model="form.kind"
          :items="kindOptions"
          item-text="label"
          item-value="value"
          outlined
          dense
          hide-details="auto"
          :rules="[v => !!v || 'Выберите тип']"
          placeholder="Выберите тип заметки"
        />
      </div>

      <!-- Text -->
      <div class="mb-6">
        <div class="text-body-2 font-weight-medium grey--text text--darken-2 mb-1">Текст шаблона</div>
        <v-textarea
          v-model="form.text"
          outlined
          dense
          hide-details="auto"
          :rules="[v => !!v.trim() || 'Текст обязателен']"
          placeholder="Введите текст шаблона..."
          rows="4"
          no-resize
        />
      </div>

      <!-- Actions -->
      <div class="d-flex justify-end" style="gap: 12px;">
        <v-btn outlined color="grey darken-1" class="text-capitalize" height="40" @click="close">
          Отмена
        </v-btn>
        <v-btn
          color="#009E60"
          dark
          depressed
          class="text-capitalize"
          height="40"
          :loading="loading"
          type="submit"
        >
          {{isEdit ? 'Сохранить' : 'Создать'}}
        </v-btn>
      </div>
    </v-form>
  </v-card>
</v-dialog>
</template>

<script>
const KIND_OPTIONS = [
  {
    value: 'strength',
    label: 'Сильные стороны',
  },
  {
    value: 'growth_area',
    label: 'Зоны роста',
  },
  {
    value: 'recommendation',
    label: 'Рекомендации',
  },
];

const ASSIGNMENT_OPTIONS = [
  { value: 'result', label: 'Итоги ассессора (общие)' },
  { value: 'competence', label: 'По компетенции' },
];

export default {
  name: 'NoteEditModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    note: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    kindOptions: KIND_OPTIONS,
    assignmentOptions: ASSIGNMENT_OPTIONS,
    form: {
      assignment: 'result',
      kind: null,
      text: '',
    },
  }),
  computed: {
    isEdit() {
      return !!this.note?.id;
    },
  },
  watch: {
    value(open) {
      if (open) this.reset();
    },
  },
  methods: {
    reset() {
      this.form = {
        assignment: this.note?.assignment || 'result',
        kind: this.note?.kind || null,
        text: this.note?.text || '',
      };
      this.$nextTick(() => this.$refs.form?.resetValidation());
    },
    close() {
      this.$emit('input', false);
    },
    submit() {
      if (!this.$refs.form.validate()) return;
      this.$emit('save', {
        assignment: this.form.assignment,
        kind: this.form.kind,
        text: this.form.text.trim(),
      });
    },
  },
};
</script>
